import { useEffect } from "react";
import ReactPixel from "react-facebook-pixel";

export function useMetaPixel() {
  const pixelId = import.meta.env.VITE_META_PIXEL_ID;

  useEffect(() => {
    if (!pixelId) {
      console.warn("⚠️ No se encontró VITE_META_PIXEL_ID en el archivo .env");
      return;
    }

    const options = {
      autoConfig: true,
      debug: import.meta.env.VITE_PUBLIC_ENVIRONMENT,
    };

    ReactPixel.init(pixelId, undefined, options);

    ReactPixel.pageView();
  }, [pixelId]);

  const trackEvent = (eventName: string, data?: Record<string, any>) => {
    ReactPixel.track(eventName, data);
  };

  return { trackEvent };
}
